import { TextField } from "@shopify/polaris";
import { FieldRenderProps } from "react-final-form";
import { FC } from "react";

interface SelectedProductsFieldProps extends FieldRenderProps<any> {
    showErrorAfterBothTouched?: boolean;
}

const LowStockLevelField: FC<SelectedProductsFieldProps> = ({ input, prefix, label, meta, min, showErrorAfterBothTouched = true, onBlur, }) => {
    const { touched, error, submitFailed } = meta;

    const showError = error && ((showErrorAfterBothTouched && touched) || submitFailed);

    return (
        <TextField
            label={label}
            value={input.value}
            onChange={input.onChange}
            autoComplete="off"
            prefix={prefix}
            type="number"
            error={showError ? error : undefined}
            onBlur={(event: React.FocusEvent<HTMLElement>) => {
                input.onBlur(event);
                if (onBlur) onBlur(event);
            }}
        />
    );
};

export default LowStockLevelField;
